import {
  IconClock,
  IconUsers,
  IconUserCog,
  IconBriefcase,
  IconFileInvoice,
  IconReceipt,
  IconChartBar,
  IconUserSearch,
  IconListCheck
} from '@tabler/icons-react';
import { NavItemWithPermissions } from './menu-permission/NavItemTypeExtended';
import { permissions } from 'utils/permissions';

const billing: NavItemWithPermissions = {
  id: 'billing',
  title: '',
  type: 'group',
  children: [
    {
      id: 'kpi-dashboard',
      title: 'kpi-dashboard.title',
      type: 'item',
      url: '/kpi',
      icon: IconChartBar,
      breadcrumbs: false,
      permissions: [permissions.kpi.KPI_VIEW]
    },
    {
      id: 'timesheets',
      title: 'timesheets.title',
      type: 'item',
      url: '/timesheets',
      icon: IconClock,
      breadcrumbs: false,
      permissions: [permissions.timesheet.TIMESHEET_LIST]
    },
    {
      id: 'workers',
      title: 'workers.title',
      type: 'item',
      url: '/workers',
      icon: IconUsers,
      breadcrumbs: false,
      permissions: [permissions.worker.WORKER_LIST]
    },
    {
      id: 'users',
      title: 'users.title',
      type: 'item',
      url: '/users',
      icon: IconUserCog,
      breadcrumbs: false,
      permissions: [permissions.user.USER_LIST]
    },
    {
      id: 'projects',
      title: 'projects.title',
      type: 'item',
      url: '/projects',
      icon: IconBriefcase,
      breadcrumbs: false,
      permissions: [permissions.project.PROJECT_LIST],
      roles: ['Owner', 'Assistant', 'Subcontractor', 'SubcontractorManager']
    },
    {
      id: 'talent-pool',
      title: 'Emberi pool',
      type: 'item',
      url: '/talent-pool',
      icon: IconUserSearch,
      breadcrumbs: false,
      permissions: [permissions.talentPool.TALENT_POOL_LIST],
      roles: ['Owner', 'Assistant']
    },
    {
      id: 'talent-competencies',
      title: 'Kompetenciák',
      type: 'item',
      url: '/talent-competencies',
      icon: IconListCheck,
      breadcrumbs: false,
      permissions: [permissions.talentPool.TALENT_POOL_LIST],
      roles: ['Owner', 'Assistant']
    },
    {
      id: 'recruitment',
      title: 'Pozíciók és jelöltek',
      type: 'item',
      url: '/recruitment',
      icon: IconBriefcase,
      breadcrumbs: false,
      roles: ['Owner', 'Assistant']
    },
    {
      id: 'tig',
      title: 'tig.title',
      type: 'item',
      url: '/tigs',
      icon: IconReceipt,
      breadcrumbs: false,
      permissions: [permissions.tig.TIG_LIST]
    },
    {
      id: 'invoices',
      title: 'invoices.title',
      type: 'item',
      url: '/invoices',
      icon: IconFileInvoice,
      breadcrumbs: false,
      permissions: [permissions.invoice.INVOICE_LIST]
    }
  ]
};

export default billing;
